export const SharePercentColumn = [


  {
    accessor: "hub",
    Header: "هاب",
    key: "hub",
    header: "هاب",
  },
  {
    accessor: "type",
    Header: "روش محاسبه حق السهم",
    key: "type",
    header: "روش محاسبه حق السهم",
  },
  {
    accessor: "validFrom",
    Header: "از تاریخ اعتبار",
    key: "validFrom",
    header: "از تاریخ اعتبار",
  },
  {
    accessor: "validTo",
    Header: "تا تاریخ اعتبار",
    key: "validTo",
    header: "تا تاریخ اعتبار",
  },

  {
    accessor: "isActive",
    Header: "وضعیت",
    key: "isActive",
    header: "وضعیت",
  },
 

  {
    Header: "عملیات",
    accessor: "operation",
    key: "",
    header: "",
  },
]
